import { Flex, HStack } from '@chakra-ui/react';
import { FaTimes } from 'react-icons/fa';
import ProductFieldInput from 'components/common/ProductFieldInput';
import { IconButton } from 'components/UI';

type ParamEditListProps = {
  valueKey: string;
  item: { [key: string]: string };
  inKey: string;
  parameter: { type: string; inputType: string };
  paramKey: string;
  onExpressionChange(a: string, b: string, c: object, d: boolean): void;
  deleteListItem(a: string, b: string, c: string): void;
};

const ParameterEditListItem = ({
  valueKey,
  item,
  inKey,
  parameter,
  paramKey,
  onExpressionChange,
  deleteListItem,
}: ParamEditListProps) => {
  if (parameter.inputType !== 'select') return null;

  let dispName = item.displayName;
  let { value } = item;

  if (dispName === undefined) {
    if (value === undefined) {
      dispName = item as unknown as string;
      value = item as unknown as string;
    }
  }
  const val1Name = 'displayName';
  const val2Name = 'value';

  if (parameter.type === 'boolean') {
    return (
      <HStack
        sx={{
          flex: 1,
          m: 5,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Flex flex={1} mx={2.5}>
          <ProductFieldInput
            name="displayName"
            value={dispName}
            onChange={(e) => {
              const data = {
                [val1Name]: e.target.value,
                [val2Name]: value,
              };
              onExpressionChange(valueKey, inKey, data, false);
            }}
          />
        </Flex>
        <Flex
          sx={{
            flex: 1,
            mx: 2.5,
            textTransform: 'uppercase',
            justifyContent: 'center',
          }}
        >
          {value.toString()}
        </Flex>
      </HStack>
    );
  }

  value = value.toString();
  return (
    <HStack
      sx={{
        flex: 1,
        m: 5,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Flex flex={1} mx={2.5}>
        <ProductFieldInput
          name="displayName"
          value={dispName}
          onChange={(e) => {
            const data = {
              [val1Name]: e.target.value,
              [val2Name]: value,
            };

            onExpressionChange(valueKey, inKey, data, false);
          }}
        />
      </Flex>

      <Flex flex={1} mx={2.5}>
        <ProductFieldInput
          type="text"
          name="expression"
          value={value}
          onChange={(e) => {
            const data = {
              [val1Name]: dispName,
              [val2Name]: e.target.value,
            };

            onExpressionChange(valueKey, inKey, data, false);
          }}
        />
      </Flex>

      <IconButton
        aria-label="Remove parameter"
        onClick={() => {
          deleteListItem(paramKey, valueKey, inKey);
        }}
        icon={<FaTimes />}
      />
    </HStack>
  );
};

export default ParameterEditListItem;
